import CustomButton from "components/Atoms/CustomButton"
import StaticSelector from "components/Atoms/StaticSelector"
import StringInput from "components/Atoms/StringInput"
import ButtonMutation from "components/Molecules/ButtonMutation"
import FileUpload from "components/Molecules/FileUpload"
import FormController from "components/Molecules/FormController"
import { ADD_UPDATE_ORDER_TRANSACTION } from "graphql/order/order.mutations"
import { getErrors } from "hooks/useErrors"
import { cloneDeep, set } from "lodash-es"
import transanctionModel from "models/transanction.model"
import React, { useMemo, useState } from "react"
import { useNavigate } from "react-router-dom"
import { ErrorToast, SuccessToast } from "utils/AppToaster"
import { inr } from "utils/formatters.utils"
import { PAYMENT_METHODS } from "data/static.items"
const OrderPayment = ({ order, onPaymentComplete }) => {
  const navigate = useNavigate()
  const outstanding = order?.totalAmount - order?.totalPaid
  const orderId = order?.id
  const [state, setState] = useState<any>({})
  const parsedVariables = useMemo(() => {
    return {
      orderId,
      amount: state?.amount,
      referenceId: state?.referenceId,
      status: state?.status?.id,
      paymentMethod: state?.paymentMethod?.id,
      attachment: state.attachment
        ? {
            url: state.attachment,
            mediaType: "PHT",
          }
        : undefined,
    }
  }, [state, orderId])

  function handleChange(path, value) {
    const stateCopy = cloneDeep(state)
    set(stateCopy, path, value)
    setState(stateCopy)
  }

  return (
    <>
      <FormController source={state} onChange={handleChange}>
        <div className="mb-3">
          Amount <span className="vt-success">{inr(order.totalPaid)}</span>/{" "}
          <span className="vt-danger">{inr(order.totalAmount)}</span>{" "}
          <span className="ml-6">Outstanding {inr(outstanding)}</span>
        </div>
        <div className="grid grid-cols-12 gap-4">
          <div className="col-span-4">
            <StringInput
              required
              path="amount"
              big={false}
              leftIcon="rupee"
              label="Amount"
              type="number"
            />
          </div>
          <div className="col-span-4">
            <StaticSelector
              required
              items={[
                {
                  id: "CAP",
                  name: "Credit",
                },
                {
                  id: "REF",
                  name: "Debit",
                },
              ]}
              path="status"
              label="Transaction Type"
            />
          </div>

          <div className="col-span-4">
            <StaticSelector
              required
              items={PAYMENT_METHODS}
              path="paymentMethod"
              label="Payment Method"
            />
          </div>
        </div>
        <div className="grid grid-cols-12 gap-4 mt-3">
          <div className="col-span-4">
            <StringInput big={false} label="Reference ID" path="referenceId" />
          </div>
          <div className="col-span-4">
            <FileUpload label="Photo" foldername="payments" path="attachment" />
          </div>
        </div>
        <div className="flex justify-end">
          <CustomButton
            icon="cross"
            text="Skip"
            data-testid="skip-button"
            className="mr-3"
            onClick={e => {
              navigate("/d/ecom/orders", { replace: true })
            }}
          />
          <ButtonMutation
            onError={() =>
              ErrorToast("Unable to add transanction, please try again!")
            }
            onCompleted={({ addUpdateOrderTransaction: auot }) => {
              const ot = auot?.orderTransaction
              const order = ot?.order

              SuccessToast(
                `Successfully added a payment of ${inr(ot?.amount)} for order ${
                  order?.trackingCode
                }`
              )
              setState({})
              onPaymentComplete(order)
              navigate("/d/ecom/orders", { replace: true })
            }}
            validate={params => {
              const errors = getErrors({
                state: params,
                schema: transanctionModel,
                abortEarly: true,
              })
              if (errors?.latest) {
                return ErrorToast(errors?.latest)
              }
              if (params.amount > outstanding && params?.status === "CAP") {
                return ErrorToast(
                  `Payment Amount :  ${inr(
                    params.amount
                  )} exceeds the outstanding : ${inr(outstanding)},
                    payment amount cannot be greater than the outstanding`
                )
              }
              return true
            }}
            icon="confirm"
            text="Transaction"
            mutation={ADD_UPDATE_ORDER_TRANSACTION}
            variables={parsedVariables}
            data-testid="trasaction-button"
          />
        </div>
      </FormController>
    </>
  )
}

export default OrderPayment
